module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n \n<!-- <div class=\"jumbotron\">\n    <div class=\"container\">\n        <div class=\"col-sm-8 col-sm-offset-2\"> -->\n\t\t\t\n            <alert></alert>\n             <router-outlet></router-outlet>\n            \t\t\n\n        <!-- </div>\n    </div>\n</div>\n -->"


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main